function ContentNotFound({ text = null }) {
  return (
    <div style={{ textAlign: "center" }}>
      {text ? text : "No Posts Found!!"}
    </div>
  );
}

export default ContentNotFound;
